var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9281 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9281 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14157.021 6783.243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4894.149,1494.491h-9.825a1.291,1.291,0,0,1-1.453-1.46q0-8.428,0-16.855c0-.785.465-1.239,1.165-1.145a.945.945,0,0,1,.854.906c.011.142,0,.285,0,.427v15.574c0,.535,0,.536.532.536q9.245,0,18.487,0a1.09,1.09,0,0,1,1.175.632.983.983,0,0,1-.881,1.384c-.375.016-.751,0-1.126,0Z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5065.682,1498.234a2.811,2.811,0,0,1-2.776-2.771,2.751,2.751,0,0,1,2.765-2.77,2.809,2.809,0,0,1,2.764,2.74A2.847,2.847,0,0,1,5065.682,1498.234Zm.7-2.784a.722.722,0,0,0-1.443.018.722.722,0,1,0,1.443-.018Z",
    transform: "translate(-166.046 -16.301)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5044.98,1585.423a2.756,2.756,0,1,1,2.763,2.773A2.79,2.79,0,0,1,5044.98,1585.423Zm2.743.728a.7.7,0,0,0,.737-.72.751.751,0,0,0-.739-.74.814.814,0,0,0-.727.724A.719.719,0,0,0,5047.723,1586.151Z",
    transform: "translate(-149.513 -99.287)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4959.139,1602.9a2.056,2.056,0,0,1-2.016,2.034,2.01,2.01,0,0,1-2.094-2.024,1.959,1.959,0,0,1,2.048-2.075A1.993,1.993,0,0,1,4959.139,1602.9Z",
    transform: "translate(-66.551 -116.045)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4993.077,1528.9a2.049,2.049,0,1,1-2.043,2.077A2.029,2.029,0,0,1,4993.077,1528.9Z",
    transform: "translate(-99.758 -49.692)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAct);
export default __webpack_public_path__ + "static/media/icon-act.6b827ecfd731f317645cdcf902736e2c.svg";
export { ForwardRef as ReactComponent };